var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    { attrs: { name: "fade", mode: "out-in" } },
    [
      _vm.loading
        ? _c("loader")
        : _c("form", { staticClass: "quotetool__step" }, [
            _c("div", { staticClass: "container" }, [
              _c(
                "div",
                { staticClass: "row quotetool__step-heading-container" },
                [
                  _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                    _c("h2", { staticClass: "quotetool__step-heading" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.labels.stepThreeTitle) +
                          "\n                    "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                    _c("span", { staticClass: "quotetool__step-sub-heading" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.labels.stepThreeEstimateUsageLabel) +
                          " "
                      ),
                      _c("strong", [
                        _vm._v(_vm._s(_vm.annualUsage) + " m"),
                        _c("sup", [_vm._v("3")]),
                      ]),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "quotetool__step-table-container" }, [
                _c("table", { staticClass: "responsive-table" }, [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [
                        _vm._v(_vm._s(_vm.labels.stepThreeTarrifHeading)),
                      ]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(
                          _vm._s(
                            _vm.labels.stepThreeEstimateAnnualCostHeading
                          ) + "*"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(
                          _vm._s(
                            _vm.labels.stepThreeTotalEstimatedSavingsHeading
                          ) + "**"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(_vm._s(_vm.labels.stepThreeKeyTermsHeading)),
                      ]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(
                          _vm._s(_vm.labels.stepThreePaymentExtrasHeading)
                        ),
                      ]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(_vm._s(_vm.labels.stepThreeNextStepHeading)),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("tbody", [
                    _c("tr", [
                      _c("td", [
                        _c("p", [
                          _c("strong", [_vm._v("1 Year")]),
                          _vm._v(" Source for Business Plan"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          attrs: {
                            "data-label":
                              _vm.labels.stepThreeEstimateAnnualCostHeading +
                              "*",
                          },
                        },
                        [
                          _c("p", { staticClass: "highlight--grey" }, [
                            _vm._v(
                              _vm._s(_vm._f("toCurrency")(_vm.oneYearTotal, 2))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("quote-popup", {
                            ref: "popup1",
                            attrs: {
                              length: "1",
                              calculation: _vm.oneYearCalculation,
                              "open-label":
                                _vm.labels.stepThreeSeeCalculationOpenedLabel,
                              "close-label":
                                _vm.labels.stepThreeSeeCalculationClosedLabel,
                            },
                            on: { open: _vm.handlePopupOpen },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { attrs: { "data-label": "Total estimated saving**" } },
                        [
                          _vm.oneYearSaving < 0
                            ? _c(
                                "p",
                                { staticClass: "highlight--red u-mr-7" },
                                [
                                  _vm._v(
                                    "+ " +
                                      _vm._s(
                                        _vm._f("toCurrency")(
                                          Math.abs(_vm.oneYearSaving),
                                          2
                                        )
                                      )
                                  ),
                                ]
                              )
                            : _c(
                                "p",
                                { staticClass: "highlight--green u-mr-7" },
                                [
                                  _vm._v(
                                    "- " +
                                      _vm._s(
                                        _vm._f("toCurrency")(
                                          Math.abs(_vm.oneYearSaving),
                                          2
                                        )
                                      )
                                  ),
                                ]
                              ),
                          _vm._v(" "),
                          _c("p", [_vm._v("vs default tariff")]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { attrs: { "data-label": "Key contract terms" } },
                        [
                          _c("ul", [
                            _c("li", [
                              _vm._v("Ends " + _vm._s(_vm.oneYearDate)),
                            ]),
                            _vm._v(" "),
                            _c("li", [_vm._v("Bi-annual bills issued")]),
                            _vm._v(" "),
                            _c("li", [_vm._v("Bi-annual meter reads")]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { attrs: { "data-label": "Payment & extras" } },
                        [
                          _c("ul", [
                            _c("li", [_vm._v("Pay monthly")]),
                            _vm._v(" "),
                            _c("li", [_vm._v("14 day payment terms")]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", { attrs: { "data-label": "Next step" } }, [
                        _c(
                          "button",
                          {
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.chooseContract(1)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.labels.stepThreeChooseContractButton)
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _c("p", [
                          _c("strong", [_vm._v("3 Year")]),
                          _vm._v(" Source for Business Plan"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          attrs: {
                            "data-label":
                              _vm.labels.stepThreeEstimateAnnualCostHeading +
                              "*",
                          },
                        },
                        [
                          _c("p", { staticClass: "highlight--grey" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("toCurrency")(_vm.threeYearTotal, 2)
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("quote-popup", {
                            ref: "popup3",
                            attrs: {
                              length: "3",
                              calculation: _vm.threeYearCalculation,
                              "open-label":
                                _vm.labels.stepThreeSeeCalculationOpenedLabel,
                              "close-label":
                                _vm.labels.stepThreeSeeCalculationClosedLabel,
                            },
                            on: { open: _vm.handlePopupOpen },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { attrs: { "data-label": "Total estimated saving**" } },
                        [
                          _vm.threeYearSaving < 0
                            ? _c(
                                "p",
                                { staticClass: "highlight--red u-mr-7" },
                                [
                                  _vm._v(
                                    "+ " +
                                      _vm._s(
                                        _vm._f("toCurrency")(
                                          Math.abs(_vm.threeYearSaving),
                                          2
                                        )
                                      )
                                  ),
                                ]
                              )
                            : _c(
                                "p",
                                { staticClass: "highlight--green u-mr-7" },
                                [
                                  _vm._v(
                                    "- " +
                                      _vm._s(
                                        _vm._f("toCurrency")(
                                          Math.abs(_vm.threeYearSaving),
                                          2
                                        )
                                      )
                                  ),
                                ]
                              ),
                          _vm._v(" "),
                          _c("p", [_vm._v("vs default tariff")]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { attrs: { "data-label": "Key contract terms" } },
                        [
                          _c("ul", [
                            _c("li", [
                              _vm._v("Ends " + _vm._s(_vm.threeYearDate)),
                            ]),
                            _vm._v(" "),
                            _c("li", [_vm._v("Bi-annual bills issued")]),
                            _vm._v(" "),
                            _c("li", [_vm._v("Bi-annual meter reads")]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { attrs: { "data-label": "Payment & extras" } },
                        [
                          _c("ul", [
                            _c("li", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("toCurrency")(_vm.threeYearDiscount, 2)
                                ) + " loyalty discount"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [_vm._v("Pay monthly")]),
                            _vm._v(" "),
                            _c("li", [_vm._v("14 day payment terms")]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", { attrs: { "data-label": "Next step" } }, [
                        _c(
                          "button",
                          {
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.chooseContract(3)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.labels.stepThreeChooseContractButton)
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("tr", [
                      _c("td", [
                        _c("p", [
                          _c("strong", [_vm._v("5 Year")]),
                          _vm._v(" Source for Business Plan"),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          attrs: {
                            "data-label":
                              _vm.labels.stepThreeEstimateAnnualCostHeading +
                              "*",
                          },
                        },
                        [
                          _c("p", { staticClass: "highlight--grey" }, [
                            _vm._v(
                              _vm._s(_vm._f("toCurrency")(_vm.fiveYearTotal, 2))
                            ),
                          ]),
                          _vm._v(" "),
                          _c("quote-popup", {
                            ref: "popup5",
                            attrs: {
                              length: "5",
                              calculation: _vm.fiveYearCalculation,
                              "open-label":
                                _vm.labels.stepThreeSeeCalculationOpenedLabel,
                              "close-label":
                                _vm.labels.stepThreeSeeCalculationClosedLabel,
                            },
                            on: { open: _vm.handlePopupOpen },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { attrs: { "data-label": "Total estimated saving**" } },
                        [
                          _vm.fiveYearSaving < 0
                            ? _c(
                                "p",
                                { staticClass: "highlight--red u-mr-7" },
                                [
                                  _vm._v(
                                    "+ " +
                                      _vm._s(
                                        _vm._f("toCurrency")(
                                          Math.abs(_vm.fiveYearSaving),
                                          2
                                        )
                                      )
                                  ),
                                ]
                              )
                            : _c(
                                "p",
                                { staticClass: "highlight--green u-mr-7" },
                                [
                                  _vm._v(
                                    "- " +
                                      _vm._s(
                                        _vm._f("toCurrency")(
                                          Math.abs(_vm.fiveYearSaving),
                                          2
                                        )
                                      )
                                  ),
                                ]
                              ),
                          _vm._v(" "),
                          _c("p", [_vm._v("vs default tariff")]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { attrs: { "data-label": "Key contract terms" } },
                        [
                          _c("ul", [
                            _c("li", [
                              _vm._v("Ends " + _vm._s(_vm.fiveYearDate)),
                            ]),
                            _vm._v(" "),
                            _c("li", [_vm._v("Bi-annual bills issued")]),
                            _vm._v(" "),
                            _c("li", [_vm._v("Bi-annual meter reads")]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        { attrs: { "data-label": "Payment & extras" } },
                        [
                          _c("ul", [
                            _c("li", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("toCurrency")(_vm.fiveYearDiscount, 2)
                                ) + " loyalty discount"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("li", [_vm._v("Pay monthly")]),
                            _vm._v(" "),
                            _c("li", [_vm._v("14 day payment terms")]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", { attrs: { "data-label": "Next step" } }, [
                        _c(
                          "button",
                          {
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.chooseContract(5)
                              },
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.labels.stepThreeChooseContractButton)
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("p", {
                  staticClass: "quotetool__step-table-compliance-text",
                  domProps: {
                    innerHTML: _vm._s(_vm.labels.stepThreeComplianceText),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  staticClass: "quotetool__step-table-compliance-text",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.labels.stepThreeAdditionalComplianceText
                    ),
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("section", { staticClass: "section--light-blue" }, [
              _c("div", { staticClass: "container container--4-col" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs-12 text-center" }, [
                    _c("h2", [
                      _vm._v(_vm._s(_vm.labels.stepThreeCustomerAccessHeading)),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-xs-12 col-sm-6 col-lg-3" }, [
                    _c(
                      "div",
                      { staticClass: "container--4-col__col-wrapper" },
                      [
                        _c("img", {
                          attrs: { src: "/dist/img/shield-test.png" },
                        }),
                        _vm._v(" "),
                        _c("h3", [
                          _vm._v(
                            _vm._s(
                              _vm.labels.stepThreeCustomerAccessColumnOneHeading
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.labels.stepThreeCustomerAccessColumnOneContent
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-12 col-sm-6 col-lg-3" }, [
                    _c(
                      "div",
                      { staticClass: "container--4-col__col-wrapper" },
                      [
                        _c("img", {
                          attrs: { src: "/dist/img/understand-icon.png" },
                        }),
                        _vm._v(" "),
                        _c("h3", [
                          _vm._v(
                            _vm._s(
                              _vm.labels.stepThreeCustomerAccessColumnTwoHeading
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.labels.stepThreeCustomerAccessColumnTwoContent
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-12 col-sm-6 col-lg-3" }, [
                    _c(
                      "div",
                      { staticClass: "container--4-col__col-wrapper" },
                      [
                        _c("img", { attrs: { src: "/dist/img/tap-icon.png" } }),
                        _vm._v(" "),
                        _c("h3", [
                          _vm._v(
                            _vm._s(
                              _vm.labels
                                .stepThreeCustomerAccessColumnThreeHeading
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.labels
                                .stepThreeCustomerAccessColumnThreeContent
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-xs-12 col-sm-6 col-lg-3" }, [
                    _c(
                      "div",
                      { staticClass: "container--4-col__col-wrapper" },
                      [
                        _c("img", {
                          attrs: { src: "/dist/img/enhance-icon.png" },
                        }),
                        _vm._v(" "),
                        _c("h3", [
                          _vm._v(
                            _vm._s(
                              _vm.labels
                                .stepThreeCustomerAccessColumnFourHeading
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.labels
                                .stepThreeCustomerAccessColumnFourContent
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }